module.exports = __webpack_public_path__ + "img/icon-sofort.e77313b2.svg";